<div class="task-modal-container">
  <div class="task-title">
    <h2>{{ isEditMode ? "Editar ítem" : "Agregar ítem" }}</h2>
  </div>
  <div class="body">
    <form [formGroup]="taskForm">
      <div class="field-group">
        <label for="itemSearch">Código interno o descripción <span class="required-mark">*</span></label>
        <input
          type="text"
          id="itemSearch"
          placeholder="Buscar por código interno o descripción"
          tabindex="0"
          [value]="searchText"
          [disabled]="isEditMode"
          (input)="onSearchChange($any($event.target).value)"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete #auto="matAutocomplete">
          @for (article of filteredArticles; track article.id) {
            <mat-option (click)="selectItem(article)">
              {{ article.internalCode }} - {{ article.name }}
            </mat-option>
          }
        </mat-autocomplete>
        @if (submitted && !selectedItem) {
          <mat-error>Debe seleccionar un ítem.</mat-error>
        }
      </div>

      @if (selectedItem) {
        <div class="field-group">
          <label>Alias</label>
          <div class="readonly-field">{{ selectedItem.alias }}</div>
        </div>
        <div class="field-group">
          <label>Categoría</label>
          <div class="readonly-field">{{ getItemCategoryName(selectedItem.itemCategoryId) }}</div>
        </div>
        <div class="field-group">
          <label>Tipo</label>
          <div class="readonly-field">{{ getTypeLabel(selectedItem.type) }}</div>
        </div>
      }

      <div class="field-group last-field-group">
        <label for="quantity">Cantidad <span class="required-mark">*</span></label>
        <input
          type="text"
          inputmode="decimal"
          id="quantity"
          formControlName="quantity"
          placeholder="Cantidad"
          appTwoDigitDecimalNumber
          (input)="onQuantityInput($event)"
          tabindex="0"
        />
        @if (
          taskForm.get('quantity')?.touched &&
          taskForm.get('quantity')?.hasError('required')
        ) {
          <mat-error>Campo obligatorio.</mat-error>
        }
      </div>
    </form>
  </div>
  <div class="buttons-footer justify-content-end">
    <button class="ind-button-lite" (click)="closeClick()" tabindex="0">
      <span class="text-buttons">Cancelar</span>
    </button>
    <button class="ind-button" (click)="onSubmit()" tabindex="0">
      <span class="text-buttons">Guardar</span>
    </button>
  </div>
</div>
